<template>
  <aside
    class="ten-aside"
    :style="_asideStyle"
    v-bind="$attrs"
  >
    <!-- @slot Aside 内容 -->
    <slot />
  </aside>
</template>

<script>
const name = 'ten-aside';
export default {
  name,
  props: {
    /**
     * 边栏 aside 宽度
     */
    width: {
      type: [Number, String],
      default: 256,
    },
  },
  computed: {
    _asideStyle() {
      return {
        width: `${this.width}px`,
      };
    },
  },
};
</script>
